// import Vue from 'vue'
import __C from '@/primitives/_constant_'
import { ApplicationService, ChartLibraryService, PageComponentService} from '@/services'

const _appService = new ApplicationService()
const _pageComponentService = new PageComponentService()
const _chartLibraryService = new ChartLibraryService()

export default {
  namespaced: true,
  state: {
    datagridItem: {},
    previewTitle: '',
    previewItems: [],
    summaryData: [],        
    containerIndex: 0,
    containerAdded: -1,
    controllerRoleNo: '',
  },
  mutations: {
    setDatagridItem(state, item) {
      if (Object.keys(item).length > 0) {
        state.datagridItem = {
          ...state.datagridItem,
          ...item,
        }
      } else {
        state.datagridItem = {}
      }
    },
    setEmpty(state) {
      state.datagridItem = {}
      state.previewItems = []
      state.summaryData = []
      state.previewTitle = ''
      state.containerIndex = 0
      state.containerAdded = -1
    },
    setPreviewTitle(state, title) {
      state.previewTitle = title
    },
    setPreviewItems(state, items) {
      if (Array.isArray(items)) {
        state.previewItems = items
        return
      }

      // Some callers/services may return an object wrapper (e.g., { dataList: [...] })
      if (items && Array.isArray(items.dataList)) {
        state.previewItems = items.dataList
        return
      }

      state.previewItems = []
    },
    setPreviewSummaryData(state, sumData) {
      state.summaryData = sumData
    },
    setContainerIndex(state, index) {
      state.containerIndex = index
    },
    setContainerAdded(state, index) {
      state.containerAdded = index
    },
    setControllerRoleNo(state, no) {
      state.controllerRoleNo = no
    },
  },
  getters: {
    general: (state) => ({
      name: state.datagridItem.name || '',
      phaseCode: state.datagridItem.phaseCode || '',
      groupCode: state.datagridItem.groupCode || '',
      itemCode: state.datagridItem.itemCode || '',
      subItemCode: state.datagridItem.subItemCode || '',
      desc: state.datagridItem.desc || '',
    }),
    database: (state) => ({
      dbName: state.datagridItem.dbName || '',
      schemaName: state.datagridItem.schemaName || '',
      tableName: state.datagridItem.tableName || '',
      directAccess: state.datagridItem.directAccess || '',
      version: state.datagridItem.version || '',
      jsonProps: state.datagridItem.jsonProps || '',
      qApplied: state.datagridItem.qApplied || '',
      qDataset: state.datagridItem.qDataset || '',
      qSp: state.datagridItem.qSp || '',
      qSummary: state.datagridItem.qSummary || '',
      qTotalRows: state.datagridItem.qTotalRows || '',
    }),
    dataSource: (state) => {
      return state.datagridItem.dbName &&
        state.datagridItem.schemaName &&
        state.datagridItem.tableName
        ? `${state.datagridItem.dbName}.${state.datagridItem.schemaName}.${state.datagridItem.tableName}`
        : ''
    },
    tableAttrs: (state) => ({
      pagination:
        state.datagridItem.tableAttrs && state.datagridItem.tableAttrs.pagination
          ? state.datagridItem.tableAttrs.pagination
          : {},
      table: state.datagridItem.tableAttrs || {},
      header: state.datagridItem.headerAttrs || {},
      body: state.datagridItem.bodyAttrs || {},
      group: state.datagridItem.groupAttrs || {},
      style: state.datagridItem.styleAttrs || {},
      svg: state.datagridItem.svgAttrs || {},
    }),
  },
  actions: {
    getChartItems({ rootState }, attrs) {
      return new Promise((resolve) => {
        _chartLibraryService.getChartList(
          attrs.catCode,
          'ALL', // in DEV mode. [attrs.phaseCode] in production mode,
          'ALL', // in DEV mode. [attrs.itemCode] in production mode,
          (item) => {
            resolve(item)
          },
        )
      })
    },
    getDatagridItem({ commit }, params) {
      return new Promise((resolve) => {
        // _pageComponentService.getDatatables(null, null, null, null, idx, (item) => {
        //   console.log('Datagrid Module - getDatagridItem', item)
        //   commit('setDatagridItem', item[0])
        //   resolve(true)
        // })
        
        let params_ = new URLSearchParams()
        params_.append('idx', params.idx)
        params_.append('catCode', __C.PAGE_COMPONENT.TYPE_PAGE) // Page | Modal
        params_.append('fValues', '')
        params_.append('reqType', __C.DASHBOARD.BUILDER_MODE_LAYOUT)

        _appService.getDatatableChart(params_, (res) => {
          commit('setDatagridItem', res.datatable)
          resolve(res.chartItems)
        })
      })
    },
    getDatatablePreview({ commit }, idx) {
      let params = new URLSearchParams()
      params.append('idx', idx)
      params.append('catCode', 'Page') // Page | Modal
      params.append('info', '')
      params.append('iFilter', '')
      params.append('fValues', '')
      params.append('cProps', '') // Configuring properties for the Intended DataGrid
      params.append('pInfo', '') // User updated pagenation info
      params.append('reqType', 'preview')

      return new Promise((resolve) => {
        _pageComponentService.getDatatablePreview(params, (res) => {
          commit('setPreviewItems', res.dataList)
          commit('setPreviewSummaryData', res.summaryData)
          resolve(res)
        })
      })
    },
  },
}
